"use client"

import type { NftId } from "@anaconda/core/nft/types"
import { ScopeProvider } from "bunshi/react"
import { NftScope } from "./scope"

interface Props {
  children: React.ReactNode
  nftId: NftId
}

export function NftScopeProvider(props: Props) {
  return (
    <ScopeProvider scope={NftScope} value={{ nftId: props.nftId }}>
      {props.children}
    </ScopeProvider>
  )
}
